module.exports = __webpack_public_path__ + "img/shiba-loading.1cbf9c82.png";